export const ONE_TIME_LIST_ITEM = 'oneTime';

export default class OneTimeMeeting {
  constructor(props) {
    this.name = props.name;
    this.id = ONE_TIME_LIST_ITEM;
    this.isCreateOneTime = true;
  }
}
